module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "content",
    class: {
      visible: _vm.visible
    },
    attrs: {
      "id": "intro"
    }
  }, [_c('h2', [_c('md-icon', [_vm._v(_vm._s(_vm.data.icon))]), _c('span', [_vm._v(_vm._s(_vm.data.title))])], 1), _vm._v(" "), _c('section', [_c('h3', [_vm._v(_vm._s(_vm.data.location.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.location.department) + ", " + _vm._s(_vm.data.location.region))])]), _vm._v(" "), _c('section', [_c('h3', [_vm._v(_vm._s(_vm.data.description.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.description.text)
    }
  })]), _vm._v(" "), _c('div', [_c('section', [_c('h3', [_vm._v(_vm._s(_vm.data.social.title))]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    staticClass: "icon-github",
    attrs: {
      "href": "https://github.com/TokaLazy",
      "title": "Regardez mes projets GitHub",
      "target": "_blank"
    }
  }, [_vm._v("Github")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "icon-linkedin",
    attrs: {
      "href": "https://www.linkedin.com/in/steeve-clement-a8837b91/",
      "title": "Consultez mon profil LinkedIn",
      "target": "_blank"
    }
  }, [_vm._v("LinkedIn")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ddb676a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Presentation.vue
// module id = 26
// module chunks = 0